import toMap from '~/misc/toMap';

export default toMap([
  'BIDS_MADE',
  'BIDS_GET',
  'BIDS_MADE_DYNAMIC',
  'BIDS_ACCEPT',
  'BIDS_SUCCESS_MESSAGE_READED',
  'BIDS_CONFIRM'
]);



// WEBPACK FOOTER //
// ./src/modules/bids/types.js